import React from 'react';
import useAppStore from '../../../store';
import WebhookForm from '../components/WebhookForm';

function WebhooksTab() {
  const session = useAppStore((state) => state.session);
  const webhooks = useAppStore((state) => state.webhooks);
  const createWebhook = useAppStore((state) => state.createWebhook);
  const toggleWebhook = useAppStore((state) => state.toggleWebhook);
  const deleteWebhook = useAppStore((state) => state.deleteWebhook);
  const canManage = session?.role === 'agency-admin' || session?.role === 'operator';

  return (
    <div className="settings-tab">
      {canManage ? (
        <WebhookForm onSubmit={createWebhook} />
      ) : (
        <p className="settings-note">Operators and admins can manage webhooks.</p>
      )}

      <div className="settings-webhook-list">
        {webhooks.map((webhook) => (
          <article className="settings-webhook" key={webhook.id}>
            <div className="settings-webhook-main">
              <strong>{webhook.label}</strong>
              <code>{webhook.url}</code>
              <div className="settings-webhook-events">
                {webhook.events.map((event) => <code key={event}>{event}</code>)}
              </div>
            </div>
            <div className="settings-webhook-side">
              <span className="settings-muted">{webhook.lastDelivery}</span>
              <label className="settings-toggle">
                <input
                  checked={webhook.enabled}
                  disabled={!canManage}
                  onChange={() => toggleWebhook(webhook.id)}
                  type="checkbox"
                />
                <span>{webhook.enabled ? 'Enabled' : 'Paused'}</span>
              </label>
              {canManage && (
                <button className="settings-text-button danger" onClick={() => deleteWebhook(webhook.id)} type="button">
                  Delete
                </button>
              )}
            </div>
          </article>
        ))}
      </div>
      {!webhooks.length && <p className="settings-note">No webhooks yet — add one to push events to your own systems.</p>}
    </div>
  );
}

export default WebhooksTab;
